import getPresetButtons from '../api/helpers/buttons'

export default function getButtons(component, userData) {
  let buttons = []

  if (component && component.preset_buttons) {
    buttons = buttons.concat(getPresetButtons(component.preset_buttons))
  }

  const mainButtons =
    userData && component.button_repeater_key !== undefined
      ? userData[component.button_repeater_key]
      : component && component.buttons

  if (Array.isArray(mainButtons)) buttons = buttons.concat(mainButtons)

  return buttons
}
